export default "__VITE_ASSET__476c3a4e__"